import { IComponentOptions, IScope, ITemplateCacheService } from 'angular';
import { IDjangoCoupon } from '../../tn.common';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { CartService, CouponError } from '../service.tn.cart';
import enterCouponPopoverTemplate from './enter-coupon-popover.html';
import enterCouponTemplate from './enter-coupon.html';

export function populateCouponTemplateCache(
    $templateCache: ITemplateCacheService
): void {
    $templateCache.put(
        'enter-coupon.directive/enter-coupon-popover.html',
        enterCouponPopoverTemplate
    );
}
populateCouponTemplateCache.$inject = ['$templateCache'];

class EnterCouponController {
    error = '';
    code = '';
    splitFamily?: number;
    popover = this.$tnPopover.fromTemplate(
        'enter-coupon.directive/enter-coupon-popover.html',
        this.$scope
    );
    submitting = false;

    static $inject = [
        '$scope',
        '$tnPopover',
        'djangoClient',
        'tn.cart.service',
    ];
    constructor(
        protected $scope: IScope,
        protected $tnPopover: PopoverService,
        protected djangoClient: DjangoClient,
        protected cartService: CartService
    ) {
        $scope.$watch('$ctrl.code', () => {
            this.error = '';
            this.splitFamily = undefined;
        });
    }

    hide(): void {
        this.$tnPopover.hide();
    }

    splitCartLicenses(): void {
        this.cartService.splitCartLicenses(this.splitFamily);
    }

    tryApplyCouponCode(): void {
        this.error = '';
        this.splitFamily = undefined;

        if (!this.code || !this.code.trim()) {
            this.error = 'Coupon code is required.';
            return;
        }

        const couponCode = this.code.trim();
        this.submitting = true;
        this.djangoClient
            .get<IDjangoCoupon>(`/api/1/coupon/${couponCode}`)
            .then((coupon) => {
                try {
                    this.cartService.applyCoupon(coupon);
                    this.hide();
                } catch (e) {
                    if (e instanceof CouponError) {
                        this.error = e.message;
                        if (e.foundry) {
                            this.splitFamily = e.foundry;
                        }
                    }
                    if (e instanceof Error) this.error = e.message;
                    else
                        this.error =
                            'An unrecognized error occurred apply the coupon; please try again later.';
                    return;
                }
            })
            .catch((response) => {
                if (response.status === 404) {
                    this.error = 'Coupon code not found.';
                } else if (response.status === 429) {
                    this.error = 'Too many requests; please try again later.';
                } else {
                    this.error = 'An error occurred; please try again later.';
                }
            })
            .finally(() => {
                this.submitting = false;
            });
    }

    showEnterCouponPopover($event: Event): void {
        this.popover.show($event.currentTarget);
    }
}

export const EnterCouponComponentOptions: IComponentOptions = {
    controllerAs: '$ctrl',
    template: enterCouponTemplate,
    transclude: true,
    controller: EnterCouponController,
};
